import { gql } from '@apollo/client'

export const DELETE_REQUESTED_INFO_TYPE_MUTATION = gql`
  mutation deleteRequestedInfoType($id: ID!) {
    deleteRequestedInfoType(id: $id)
  }
`
